﻿/* SHALEM — capa CRO
   1) Reubica los CTA de cierre (sección shalem-cierre) después de la
      comparativa y al final de la página, y los conecta al botón real.
   2) Preselecciona fragancia y pack para que el sticky pueda comprar.
   3) Corrige las contradicciones de copy (nombres de pack).
   4) Cambia emojis por iconos y añade el precio por frasco.
   No reescribe la lógica del tema: usa los mismos clics del usuario. */
(function () {
  'use strict';

  /* ───── 1. CTA de cierre ───── */

  function reubicarCierres() {
    var pool = document.querySelector('[data-shalem-cierre-pool]');
    if (!pool) return;

    var aGarantia = pool.querySelector('[data-shalem-cierre-destino="garantia"]');
    var aFinal = pool.querySelector('[data-shalem-cierre-destino="final"]');

    var garantia = document.querySelector('.shalem-garantia30');
    if (aGarantia && garantia && garantia.parentNode) {
      garantia.parentNode.insertBefore(aGarantia, garantia);
    }

    var footer = document.querySelector('.shalem-footer2');
    if (aFinal && footer && footer.parentNode) {
      footer.parentNode.insertBefore(aFinal, footer);
    }

    if (pool.parentNode) pool.parentNode.removeChild(pool);
  }

  function botonPrincipal() {
    return document.querySelector('[data-shalem-submit]');
  }

  function zonaSelector() {
    return document.getElementById('shalem-target-fragancia') ||
           document.getElementById('shalem-target-pack');
  }

  function alClic(e) {
    var t = e.target;
    var btn = null;
    while (t && t !== document) {
      if (t.hasAttribute && t.hasAttribute('data-shalem-cierre-atc')) { btn = t; break; }
      t = t.parentNode;
    }
    if (!btn) return;
    e.preventDefault();

    var principal = botonPrincipal();
    if (principal && !principal.disabled) { principal.click(); return; }

    var zona = zonaSelector();
    if (zona) zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ───── 2. Preselección ───── */

  function preseleccionar() {
    if (!document.querySelector('.shalem-frag-btn.shalem-opcion-activa')) {
      var frag = document.querySelector('.shalem-frag-btn:not(.shalem-frag-surtido)');
      if (frag) frag.click();
    }
    if (!document.querySelector('.shalem-pack-opcion.shalem-opcion-activa')) {
      var packs = document.querySelectorAll('.shalem-pack-opcion');
      var elegido = null;
      for (var i = 0; i < packs.length; i++) {
        if ((packs[i].getAttribute('data-shalem-pack') || '').indexOf('Inicio') !== -1) {
          elegido = packs[i]; break;
        }
      }
      if (!elegido && packs.length) elegido = packs[0];
      if (elegido) elegido.click();
    }
  }

  /* ───── 3. Correcciones de copy ───── */

  function cambiar(el, de, a) {
    if (!el) return;
    var t = el.textContent;
    if (t && t.indexOf(de) !== -1) el.textContent = t.split(de).join(a);
  }

  function corregirCopy() {
    cambiar(document.querySelector('.shalem-top-score'), '4.7', '4.9');
    cambiar(document.querySelector('.shalem-frag-surtido-nota'), 'Pack Experiencia', 'el pack de 3');
    cambiar(document.querySelector('[data-shalem-surtido-aviso]'), 'el Pack Experiencia (3 un.)', 'el pack de 3 unidades');

    var urgencia = document.getElementById('shalem-urgency');
    if (urgencia) {
      urgencia.textContent = 'ENVÍO GRATIS A TODA COLOMBIA · LLEGA EN 1-2 DÍAS HÁBILES';
    }

    var contenidos = document.querySelectorAll('.shalem-pack-opcion-contenido');
    for (var i = 0; i < contenidos.length; i++) {
      // A2 — corregido: el frasco es de 40ml, no 30. Esta reescritura creaba la contradiccion.
      cambiar(contenidos[i], '3 frascos +', '3 frascos de 40 ml +');
      cambiar(contenidos[i], '6 frascos +', '6 frascos de 40 ml +');
    }

    var parrafos = document.querySelectorAll('p');
    for (var j = 0; j < parrafos.length; j++) {
      // A2 — se elimino la reescritura 'ámbar de 40ml' -> '30 ml'.
      cambiar(parrafos[j], 'vuelven al Pack Experiencia o Pro después', 'vuelven al pack de 3 o al de 6 después');
    }
  }

  /* ───── 4. Swatches, iconos y precio por frasco ───── */

  var EMOJIS = /^[\uD83C-􏰀-\uDFFF☀-➿️\s]+/;

  function swatches() {
    var botones = document.querySelectorAll('.shalem-frag-btn');
    for (var i = 0; i < botones.length; i++) {
      var texto = botones[i].querySelector('.shalem-frag-texto');
      if (!texto || texto.querySelector('.shalem-frag-punto, .shalem-frag-puntos')) continue;
      var limpio = texto.textContent.replace(EMOJIS, '').trim();
      texto.textContent = '';
      if (botones[i].classList.contains('shalem-frag-surtido')) {
        var grupo = document.createElement('span');
        grupo.className = 'shalem-frag-puntos';
        grupo.setAttribute('aria-hidden', 'true');
        ['#F5C842', '#8B3A1A', '#E8334A'].forEach(function (c) {
          var i2 = document.createElement('i');
          i2.style.background = c;
          grupo.appendChild(i2);
        });
        texto.appendChild(grupo);
      } else {
        var punto = document.createElement('span');
        punto.className = 'shalem-frag-punto';
        punto.setAttribute('aria-hidden', 'true');
        texto.appendChild(punto);
      }
      texto.appendChild(document.createTextNode(limpio));
    }
  }

  var SVG_EFECTIVO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#1A110A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>';
  var SVG_ENTREGA = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#1A110A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z"/><path d="m3 7.5 9 4.5 9-4.5"/><path d="M12 12v9"/></svg>';

  function iconosPago() {
    var items = document.querySelectorAll('.shalem-pago-icono-item');
    for (var i = 0; i < items.length; i++) {
      var emoji = items[i].querySelector('.shalem-pago-icono');
      if (!emoji) continue;
      var label = items[i].querySelector('.shalem-pago-icono-label');
      var texto = label ? label.textContent : '';
      var envoltura = document.createElement('span');
      envoltura.innerHTML = texto.indexOf('Contra') !== -1 ? SVG_ENTREGA : SVG_EFECTIVO;
      emoji.parentNode.replaceChild(envoltura.firstChild, emoji);
    }
  }

  function unidadesDe(nombre) {
    if (nombre.indexOf('Inicio') !== -1) return 1;
    if (nombre.indexOf('GRATIS') !== -1) return 3;
    if (nombre.indexOf('Pro') !== -1) return 6;
    return 0;
  }

  function precioPorFrasco() {
    var packs = document.querySelectorAll('.shalem-pack-opcion');
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].querySelector('.shalem-pack-unitario')) continue;
      var n = unidadesDe(packs[i].getAttribute('data-shalem-pack') || '');
      if (n < 2) continue;
      var precioEl = packs[i].querySelector('.shalem-pack-opcion-precio');
      if (!precioEl) continue;
      var digitos = (precioEl.textContent || '').replace(/[^0-9]/g, '');
      if (!digitos) continue;
      var unitario = Math.round(parseInt(digitos, 10) / n);
      var span = document.createElement('span');
      span.className = 'shalem-pack-unitario';
      span.textContent = '$' + unitario.toLocaleString('es-CO') + ' por frasco';
      var ahorro = packs[i].querySelector('.shalem-pack-opcion-ahorro');
      var envio = packs[i].querySelector('.shalem-pack-envio');
      if (envio) packs[i].insertBefore(span, envio);
      else if (ahorro && ahorro.nextSibling) packs[i].insertBefore(span, ahorro.nextSibling);
      else packs[i].appendChild(span);
    }
  }

  /* ───── Arranque ───── */

  function init() {
    document.addEventListener('click', alClic, false);
    reubicarCierres();
    corregirCopy();
    swatches();
    iconosPago();
    precioPorFrasco();
    setTimeout(preseleccionar, 350);
    setTimeout(preseleccionar, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
